module.exports = __webpack_public_path__ + "assets/img/goodwe-inverter.abc4d5c4.png";